module.exports = __webpack_public_path__ + "img/193.9980f3a3.jpg";